
import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const Customer = lazy(() => import("@/pages/MyCustomer/MyCustomer/Customer"));
const MyCustomer = lazy(() => import("@/pages/MyCustomer/MyCustomer/MyCustomer"));
const MyCustRequest = lazy(() => import("@/pages/MyCustomer/MyCustRequest/MyCustRequest"));
const CustomerList = lazy(() => import("@/pages/MyCustomer/MyCustomer/CustomerList"));
const BulkUpload = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkUpload/BulkUpload"));
const BulkReport = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkReport/BulkReport"));
const BulkReportView = lazy(() => import("@/pages/MyCustomer/MyCustomer/BulkReport/BulkReportView"));

const MyCustomerRoutes: RouteConfig = {
  path: "",
  element: <MyCustomer />,
  pageName: "My Customers",
  sidebar: {
    show: true,
    icon: "/assets/media/customerLogo.svg"
  },
  permission: ["CustomersView", "ViewAllCustomers"],
  children: {
    CUSTOMER: {
      path: "customers",
      element: <Customer />,
      pageName: "My Customer",
      sidebar: { show: true, icon: "" },
      children: {
        MAIN: {
          path: "",
          element: <CustomerList />,
          pageName: "My Customer",
          sidebar: { show: false },
        },
        CustomerBulkUpload: {
          path: "BulkUploadCustomer",
          element: <BulkUpload heading="Customer Bulk Upload" type="Customers" />,
          pageName: "My Customer",
          sidebar: { show: false }
        },
        BulkReportCustomer: {
          path: "BulkReportCustomer",
          element: <BulkReport />,
          pageName: "My Customer",
          sidebar: { show: false }
        },
        BulkReportCustomerView: {
          path: "BulkReportCustomer/view-report/:id",
          element: <BulkReportView />,
          pageName: "My Customer",
          sidebar: { show: false }
        }
      }
    },
    MyCustomerRequest: {
      path: "request",
      element: <MyCustRequest />,
      pageName: "Distributor Request",
      sidebar: { show: true, icon: "" },
    }
  }
}
export default MyCustomerRoutes;